import http from 'utils/http';
import { BusinessInsightsResponse } from './types';
import { getBusinessInsightsUrl } from './apiUrls';

export function getBusinessInsights(): Promise<BusinessInsightsResponse> {
  return http.get(getBusinessInsightsUrl());
}
